/* eslint-disable @typescript-eslint/no-empty-interface */
import type { GlobalAttributesT, ValidationMap, XstyledProps } from '@elliemae/ds-props-helpers';
import { PropTypes } from '@elliemae/ds-props-helpers';
import type React from 'react';

export declare namespace SvgIconT {
  export type SizeType = 'xxs' | 'xs' | 's' | 'm' | 'l' | 'xl' | 'xxl';

  export type ColorType =
    | ['neutral', '900' | '600' | '500' | '400' | '0']
    | ['danger', '900']
    | ['warning', '600' | '900']
    | ['success', '900']
    | ['brand-primary', '600' | '700' | '800'];

  export interface DefaultProps {
    component: React.ComponentType | keyof React.JSX.IntrinsicElements;
    containerProps: object;
  }

  export interface OptionalProps {
    children?: React.ReactNode;
    viewBox?: string;
    size?: SizeType;
    color?: ColorType;
    paths?: string[];
    fill?: string;
    innerRef?: React.MutableRefObject<HTMLElement | null> | ((_ref: HTMLElement) => void);
    width?: number | string;
    height?: number | string;
    className?: string;
    style?: React.CSSProperties;
  }

  export interface RequiredProps {}

  export interface Props
    extends Partial<DefaultProps>,
      RequiredProps,
      OptionalProps,
      Omit<GlobalAttributesT<HTMLSpanElement>, keyof DefaultProps | keyof OptionalProps>,
      Omit<XstyledProps, keyof DefaultProps | keyof OptionalProps> {}
}

export const defaultProps: SvgIconT.DefaultProps = {
  component: 'span',
  containerProps: {},
};

export const propTypes = {
  containerProps: PropTypes.object.description('set of properties attached to the main container'),
  size: PropTypes.oneOf(['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl']).description('size of the icon'),
  color: PropTypes.oneOfType([
    PropTypes.tuple([PropTypes.oneOf(['neutral']), PropTypes.oneOf(['900'])]),
    PropTypes.tuple([PropTypes.oneOf(['neutral']), PropTypes.oneOf(['500'])]),
    PropTypes.tuple([PropTypes.oneOf(['neutral']), PropTypes.oneOf(['400'])]),
    PropTypes.tuple([PropTypes.oneOf(['neutral']), PropTypes.oneOf(['0'])]),
    PropTypes.tuple([PropTypes.oneOf(['danger']), PropTypes.oneOf(['900'])]),
    PropTypes.tuple([PropTypes.oneOf(['warning']), PropTypes.oneOf(['600'])]),
    PropTypes.tuple([PropTypes.oneOf(['warning']), PropTypes.oneOf(['900'])]),
    PropTypes.tuple([PropTypes.oneOf(['success']), PropTypes.oneOf(['900'])]),
    PropTypes.tuple([PropTypes.oneOf(['brand-primary']), PropTypes.oneOf(['600'])]),
    PropTypes.tuple([PropTypes.oneOf(['brand-primary']), PropTypes.oneOf(['800'])]),
    PropTypes.tuple([PropTypes.oneOf(['brand-primary']), PropTypes.oneOf(['700'])]),
  ]).description('icon color'),
  className: PropTypes.string.description('html class attribute'),
  style: PropTypes.object.description('set of properties attached to the main container'),
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).description('containers element'),
  viewBox: PropTypes.string.description('view box'),
  paths: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]).description(''),
  fill: PropTypes.string.description('fill attribute'),
  innerRef: PropTypes.object.description('inner ref'),
  title: PropTypes.string.description('Adds a title html element to the svg.'),
} as ValidationMap<unknown>;
